export enum Alerts {
    OverDueDocuments = "Documentation Overdue",
    MissedVisits = "Missed Visits",
    MissedMDSignatures = "Missed MD Signatures",
    MissedTimeSheets = "Missing Time Sheets",
    TherapyScreenOrReferral = "Therapy Screen/Referral",
    NoTherapyThreeDays = "No Tx for 3 Days",
    Discrepancies = "Discrepancies",
    TimeCardImportFailures = "Time Card Import Failures"
}

export enum DashboardTaskAlertTypes {
    OverDueDocuments = 1,
    MissedVisits = 2,
    MissedMDSignatures = 3,
    MissingTimeSheets = 4,
    TherapyScreenOrReferral= 5,
    NoTherapyThreeDays = 6,
    Discrepancies = 7,
    TimeCardImportFailures = 8
};

export const DisplayToAlertTypeMap: Record<Alerts, DashboardTaskAlertTypes> = {
    [Alerts.OverDueDocuments]: DashboardTaskAlertTypes.OverDueDocuments,
    [Alerts.MissedVisits]: DashboardTaskAlertTypes.MissedVisits,
    [Alerts.MissedMDSignatures]: DashboardTaskAlertTypes.MissedMDSignatures,
    [Alerts.MissedTimeSheets]: DashboardTaskAlertTypes.MissingTimeSheets,
    [Alerts.TherapyScreenOrReferral]: DashboardTaskAlertTypes.TherapyScreenOrReferral,
    [Alerts.NoTherapyThreeDays]: DashboardTaskAlertTypes.NoTherapyThreeDays,
    [Alerts.Discrepancies]: DashboardTaskAlertTypes.Discrepancies,
    [Alerts.TimeCardImportFailures]: DashboardTaskAlertTypes.TimeCardImportFailures
}

export const AlertTypeToDisplayMap: Record<DashboardTaskAlertTypes, Alerts> = {
    [DashboardTaskAlertTypes.OverDueDocuments]: Alerts.OverDueDocuments,
    [DashboardTaskAlertTypes.MissedVisits]: Alerts.MissedVisits,
    [DashboardTaskAlertTypes.MissedMDSignatures]: Alerts.MissedMDSignatures,
    [DashboardTaskAlertTypes.MissingTimeSheets]: Alerts.MissedTimeSheets,
    [DashboardTaskAlertTypes.TherapyScreenOrReferral]: Alerts.TherapyScreenOrReferral,
    [DashboardTaskAlertTypes.NoTherapyThreeDays]: Alerts.NoTherapyThreeDays,
    [DashboardTaskAlertTypes.Discrepancies]: Alerts.Discrepancies,
    [DashboardTaskAlertTypes.TimeCardImportFailures]: Alerts.TimeCardImportFailures
};

export function getAlertType(display: Alerts): DashboardTaskAlertTypes {
    return DisplayToAlertTypeMap[display];
}

export function getAlertDisplay(alertType: DashboardTaskAlertTypes): Alerts {
    return AlertTypeToDisplayMap[alertType];
}

export enum FilterDateRange{
    LastDay = "Last Day",
    LastThreeDays = "Last 3 Days",
    LastWeek = "Last 1 Week",
    LastFourteenDays = "Last 14 Days",
    LastMonth = "Last Month"
  }

 export enum AlertDetailsEnum {
    Patient = 1,
    Therapist = 2,
    DocumentType = 3,
    Discipline = 4,
    Date = 5,
    AgendaTime = 6,
    AgendaMode = 7,
    ErrorReason = 8,
    OccurrenceCount = 9
}

export enum AlertFiltersEnum {
    Discipline = 1,
    Patient = 2,
    Therapist = 3,
    Physician = 4,
}